// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";

import App from "./App";
import Vuex from "vuex";
import router from "./router";
import moment from "../src/common/moment";
import store from "./common/store";
import axios from "./common/http";
// import index from './common/plugins/index'
// import $ from 'jquery'
import ElementUI from "element-ui";
import "layui-src/dist/css/layui.css";
import "layui-src/dist/css/modules/laydate/default/laydate.css";

import "../static/css/clear.css";
import HighCharts from "highcharts";
import VueHighcharts from "vue-highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
import Sankey from "highcharts/modules/sankey";
import Wordcloud from "highcharts/modules/wordcloud";
import treemap from "highcharts/modules/treemap";
import Funnel from "highcharts/modules/funnel";
import Highcharts3d from "highcharts/highcharts-3d";
import Funnel3d from "highcharts/modules/funnel3d";
import Cylinder from "highcharts/modules/cylinder";
import mapInit from "highcharts/modules/map";
import * as chartsZh from "./common/highcharts-zh_CN";
// H.setOptions(defaultOptionsZhCn)

import "../static/iconfont/iconfont.css";
import "../static/iconfonts-2/iconfont.css";
import "./prototype";
import * as myFilter from "../src/common/filter/filter";
import contents from "./components/common/content/content";
import contentOne from "./components/common/content/contentOne";
import contentFour from "./components/common/content/contentFour";
import contentFive from "./components/common/content/contentFive";
import contentThree from "./components/common/content/contentThree";
import contentTwo from "./components/common/content/contentTwo";
import contentSix from "./components/common/content/contentSix";
import contentSeven from "./components/common/content/contentSeven";
import twoHeader from "./components/common/content/two_header";
import oneHeader from "./components/common/content/one_header";
import thirdHeader from "./components/common/content/third_header";
import fourHeader from "./components/common/content/four_header";
import vipHeaderDialog from "./components/common/content/vip_header_dialog.vue"

/* eslint-disable no-new */
import url from "../static/url";

// 全局注册过滤器

Object.keys(myFilter).forEach((key, index, arr) => {
  Vue.filter(key, myFilter[key]);
});
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(HighCharts);
mapInit(HighCharts);
// 无数据
HighchartsNoData(HighCharts);
Highcharts3d(HighCharts);
Sankey(HighCharts);
Wordcloud(HighCharts);
treemap(HighCharts);
Funnel(HighCharts);
Funnel3d(HighCharts);
Cylinder(HighCharts);
Vue.use(VueHighcharts);

HighCharts.setOptions({ global: { useUTC: false } });
HighCharts.setOptions(chartsZh.defaultOptionsZhCn);

Vue.prototype.moment = moment;
const log = console.log.bind(console)
// 表格数据个数
Vue.prototype.filterCount = (index, num, name) => {
  // console.log(index, num, name);
    // log('改变当前汇总')
  if (name !== "当前汇总" && name !== "汇总") {
        let count = 20 * (num - 1) + 1 + index
        // log(index, num, name)
        // log(count)
        return count
  }
};
Vue.component("contents", contents);
Vue.component("contentOne", contentOne);
Vue.component("contentFour", contentFour);
Vue.component("contentFive", contentFive);
Vue.component("contentThree", contentThree);
Vue.component("contentTwo", contentTwo);
Vue.component("contentSix", contentSix);
Vue.component("contentSeven", contentSeven);
Vue.component("twoHeader", twoHeader);
Vue.component("oneHeader", oneHeader);
Vue.component("thirdHeader", thirdHeader);
Vue.component("fourHeader", fourHeader);
Vue.component("vipHeaderDialog", vipHeaderDialog);
Vue.prototype.axios = axios;
// console.log(App)
// 全局注册loading格式: this.$loading(this.loadingStyle)
let loadingStyle = dom => {
  if (!dom && (typeof dom === "object" || typeof dom === "string")) {
    return {
      customClass: "errLoading"
    };
  } else {
    return {
      background: "#FFF",
      spinner: "el-icon-loading",
      text: "拼命的加载中",
      customClass: "defineLoading",
      target: dom
    };
  }
};

Vue.prototype.loadingStyle = loadingStyle;

Vue.config.productionTip = false;
// Vue.prototype.BASE_URL = url
new Vue({
  el: "#app",
  router,
  store,
  // components: { App },
  // template: '<App/>'
  render: r => r(App)
});
